/**
 * What the competency filters answer with, apart from a real evaluator or a real period.
 *
 * Their own module rather than the filter component's: the window helpers and the hook that reads
 * the employee's periods both have to know which ids are instructions rather than periods, and a
 * component importing a helper that imports the component back is a cycle.
 */

/** The evaluator option that keeps the levels every evaluator gave. */
export const ALL_EVALUATORS = 'all';

/** The period option that reads every evaluation period. */
export const ALL_PERIODS = 'all-profiles';

/** The period option that reads between two dates the reader picks. */
export const CUSTOM_PERIOD = 'custom';

export interface SkillsetPeriod {
    /** An evaluation period id, {@link ALL_PERIODS} or {@link CUSTOM_PERIOD}. */
    filterId: string;
    fromDate: Date;
    toDate: Date;
}
